"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const CursorTwoBoxes = createSVGIcon(
  <>
    <path
      d="M22.52 30.5001H1.5C0.95 30.5001 0.5 30.0501 0.5 29.5001V27.5601C0.5 27.0101 0.95 26.5601 1.5 26.5601H22.52C23.07 26.5601 23.52 27.0101 23.52 27.5601V29.5001C23.52 30.0501 23.08 30.5001 22.52 30.5001Z"
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="0.5"
      y="0.5"
      width="23"
      height="22"
      rx="1.5"
      fill="none"
      stroke="currentColor"
    />
    <path
      d="M27.5986 13.941C27.7287 13.8393 27.8001 13.68 27.7896 13.5153C27.7791 13.3505 27.6879 13.2016 27.546 13.1173L20.6053 8.99349C20.4355 8.89257 20.2221 8.90113 20.0609 9.01533C19.8997 9.12954 19.8209 9.32796 19.8597 9.52167L21.516 17.7793C21.5502 17.9495 21.6702 18.0898 21.833 18.15C21.9959 18.2101 22.1783 18.1815 22.3149 18.0743L23.8901 16.8386L25.2891 18.8399C25.3676 18.9521 25.4886 19.0272 25.6239 19.0478C25.7593 19.0683 25.8971 19.0325 26.0053 18.9486L27.3079 17.9385C27.5189 17.7749 27.5641 17.4743 27.4105 17.2558L25.9732 15.212L27.5986 13.941Z"
      fill="white"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CursorTwoBoxes",
  { viewBox: "0 0 29 31", titleAccess: "CursorTwoBoxes" }
);
